<template>
  <div class="wrapper-map mb-4">
    <div id="map" class="bg-borders mb-4"></div>
  </div>
</template>

<script>

import mapboxgl from "mapbox-gl";
import * as mapboxInit from '../mapbox';

export default {
  name: "map-propiedad",
  props: ['lat', 'lng'],
  data() {
    return {
       accessToken: `${mapboxInit.API_KEY}`
    };
  },
  mounted() {

    mapboxgl.accessToken = this.accessToken;
    console.log("Lat:"+this.lat);
    console.log("Long:"+this.lng);
    var map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [ this.lng, this.lat],
      zoom: 14,
      showZoom: false,
      attributionControl: false
    });

    var marker = new mapboxgl.Marker({})
              .setLngLat([ this.lng,this.lat])
              .addTo(map);
  },
};
</script>
<style>
  #map{
    padding-top :0px !important;
  }
</style>
